import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { readItems, readUsers } from "@directus/sdk";
import { useSelector } from "react-redux";
import { Button, Space, Spin, Table, DatePicker, message, Tree } from "antd";
import moment from "moment";
import Chart from "react-google-charts";
const { RangePicker } = DatePicker;
const { DirectoryTree } = Tree;

function Reportetrops(props) {
  const [userselect, setUserselect] = useState();
  const [total, setTotal] = useState(0);
  const userdata = useSelector((state) => state?.userdata);
  const [datareporte, setDatareporte] = useState([]);
  const [loanding, setLoanding] = useState(false);
  const [startDate, setStartDate] = useState("2023-01-01");
  var hoy = moment();
  var hoyf = hoy.add(1, "d").format("YYYY-MM-DD");
  const [endDate, setEndDate] = useState(hoyf);
  const [vendedores, setVendedores] = useState([]);
  const [estados, setEstados] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [userIdsInTable, setUserIdsInTable] = useState([]);

  const getUsers = async () => {
    let arraycompleto = [];
    const directus = new getDirectusClient();
    try {
      const values = await directus.request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "role.name",
            "subordinados.id",
            "subordinados.first_name",
            "subordinados.role.name",
            "subordinados.subordinados.id",
            "subordinados.subordinados.first_name",
          ],
          filter: {
            superior: {
              id: {
                _eq: userdata.id,
              },
            },
          },
        })
      );
      let arraysimple = [];
      values.map((value) => {
        if (
          value.role.name === "coordinador tropas" ||
          value.role.name === "supervisor tropas" ||
          value.role.name === "tropas"
        ) {
          let arraysub = [];
          value?.subordinados?.map((sub) => {
            let promoarr = [];
            sub?.subordinados?.map((promo) => {
              promoarr.push({
                title: promo?.first_name ? promo?.first_name : promo,
                key: promo?.id ? promo?.id : promo,
              });
            });
            arraysub.push({
              title: sub?.first_name,
              key: sub?.id,
              children: promoarr,
            });
          });
          arraysimple.push({
            title: value?.first_name,
            key: value?.id,
            children: arraysub,
          });
        }
      });
      arraycompleto.push({
        title: userdata?.first_name,
        key: userdata?.id,
        disabled: userdata?.role?.name === "gerente" ? true : false,
        children: arraysimple,
      });
      setTreeData(arraycompleto);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUsers();
    let fecha = moment().format("YYYY-MM-DD");
    let fechayhorainicial = fecha + " " + "12:00:00";
    let fechayhorafinal = fecha + " " + "23:59:00";
    setStartDate(fechayhorainicial);
    setEndDate(fechayhorafinal);
  }, []);

  // Al seleccionar usuario en el árbol
  const selectTree = (ev) => {
    const userId = ev[0];
    if (!userIdsInTable.includes(userId)) {
      setUserIdsInTable(prev => [...prev, userId]);
      cargarReporte(userId, startDate, endDate, true); // append
    }
  };

  const cargarReporte = async (userselect, startDate, endDate, append = false) => {
    try {
      setLoanding(true);
      const directus = new getDirectusClient();
      const datachart = [["tipo", "Cantidad"]];

      const formatToColombiaTZ = (date) => {
        let m = moment(date);

        return m.utcOffset(-5).format("YYYY-MM-DDTHH:mm:ss-05:00");
      };
      const start = formatToColombiaTZ(startDate);
      const end = formatToColombiaTZ(endDate);
      const filter = {
        _and: [
          { vendedor_prestamo: { superior: { _eq: userselect } } },
          { date_created: { _between: [start, end] } },
        ],
      };
   

      const facturas = await directus.request(
        readItems("facturas", {
          fields: [
            "id",
            "vendedor_prestamo.id",
            "vendedor_prestamo.first_name",
            "bodega.nombre",
            "bodega.id",
            "productos.id",
            "caja",
            "tipo.tipo",
            "cliente.id",
            "cliente.first_name",
            "estado",
            "date_created",
            "productos.nombre",
            "productos.precio_unitario",
            "productos.cantidad",
            "productos.producto.grupo.impuesto",
            "consecutivo",
          ],
          filter: filter,
          limit: -1,
        })
      );

      const tipoCounts = {};
      let totalVentas = 0;
      let vendedorNombre = "";
      facturas.forEach((factura) => {
        const tipo =
          factura.tipo && factura.tipo.tipo ? factura.tipo.tipo : "Sin tipo";
        tipoCounts[tipo] = (tipoCounts[tipo] || 0) + 1;
        // Sumar ventas
        if (factura.productos && Array.isArray(factura.productos)) {
          factura.productos.forEach((prod) => {
            totalVentas += (prod.precio_unitario || 0) * (prod.cantidad || 0);
          });
        }
        if (!vendedorNombre && factura.vendedor_prestamo?.first_name) {
          vendedorNombre = factura.vendedor_prestamo.first_name;
        }
      });

      Object.entries(tipoCounts).forEach(([tipo, count]) => {
        datachart.push([tipo, count]);
      });

      const processedData = facturas.map((factura) => {
        let productosNombres = Array.isArray(factura.productos)
          ? factura.productos.map((p) => p.nombre).join(", ")
          : "";
        let productosCantidades = Array.isArray(factura.productos)
          ? factura.productos.map((p) => p.cantidad).join(", ")
          : "";
        let productosImpuestos = Array.isArray(factura.productos)
          ? factura.productos
              .map((p) =>
                p.producto && p.producto.grupo && p.producto.grupo.impuesto
                  ? p.producto.grupo.impuesto
                  : ""
              )
              .join(", ")
          : "";

        let totalFactura = 0;
        if (Array.isArray(factura.productos)) {
          factura.productos.forEach((p) => {
            let subtotal = (p.precio_unitario || 0) * (p.cantidad || 0);
            let impuesto = 0;

            if (p.producto && p.producto.grupo && p.producto.grupo.impuesto) {
              let imp = p.producto.grupo.impuesto;
              let percent = 0;
              if (typeof imp === "string") {
                percent = parseFloat(imp.replace("%", ""));
              } else if (typeof imp === "number") {
                percent = imp;
              }
              if (!isNaN(percent) && percent > 0) {
                impuesto = subtotal * (percent / 100);
              }
            }
            totalFactura += subtotal + impuesto;
          });
        }
        return {
          key: factura.id + '-' + userselect, // unique per user
          tipo:
            factura.tipo && factura.tipo.tipo ? factura.tipo.tipo : "Sin tipo",
          estado: factura.estado || "",
          cliente:
            factura.cliente && factura.cliente.first_name
              ? factura.cliente.first_name
              : factura.cliente || "",
          vendedor:
            factura.vendedor_prestamo && factura.vendedor_prestamo.first_name
              ? factura.vendedor_prestamo.first_name
              : "",
          totalFacturas: 1,
          consecutivo: factura.consecutivo || "",
          bodega:
            factura.bodega && factura.bodega.nombre
              ? factura.bodega.nombre
              : "",
          productosNombre: productosNombres,
          productosCantidad: productosCantidades,
          impuesto: productosImpuestos,
          totalFactura: `$${totalFactura.toFixed(2)}`,
          userId: userselect,
        };
      });
      if (append) {
        setVendedores(prev => [...prev, ...processedData]);
        setTotal(prev => prev + facturas.length);
        // Actualizar el gráfico con todas las facturas acumuladas
        setDatareporte(prev => {
          const newData = [["tipo", "Cantidad"]]; // Siempre empezar con el header
          const tipoCountsTotal = {};
          
          // Sumar todos los tipos existentes
          prev.forEach((item, index) => {
            if (index > 0 && item[0] && item[1]) { // Skip header
              tipoCountsTotal[item[0]] = (tipoCountsTotal[item[0]] || 0) + item[1];
            }
          });
          
          // Sumar los nuevos tipos
          Object.entries(tipoCounts).forEach(([tipo, count]) => {
            tipoCountsTotal[tipo] = (tipoCountsTotal[tipo] || 0) + count;
          });
          
          // Agregar todos los tipos al gráfico
          Object.entries(tipoCountsTotal).forEach(([tipo, count]) => {
            if (tipo && count > 0) {
              newData.push([tipo, count]);
            }
          });
          
          return newData;
        });
      } else {
        setVendedores(processedData);
        setTotal(facturas.length);
        setDatareporte(datachart);
      }
      setEstados(Object.keys(tipoCounts));
      setLoanding(false);
    } catch (error) {
      console.error("Error in cargarReporte:", error);
      setLoanding(false);
      message.error("Error al cargar el reporte");
    }
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setLoanding(true);
      const formatToColombiaTZ = (date) => {
        let m = moment(date);
        return m.utcOffset(-5).format("YYYY-MM-DDTHH:mm:ss-05:00");
      };
      const start = formatToColombiaTZ(dateStrings[0]);
      const end = formatToColombiaTZ(dateStrings[1]);
      setStartDate(start);
      setEndDate(end);
      // Limpiar tabla y recargar todos los usuarios que ya estaban seleccionados
      setVendedores([]);
      setTotal(0);
      userIdsInTable.forEach(userId => {
        cargarReporte(userId, start, end, true);
      });
    }
  };

  // Columnas fijas para la tabla de facturas
  const columns = [
    {
      title: "Tipo",
      dataIndex: "tipo",
      key: "tipo",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
    },
    {
      title: "Cliente",
      dataIndex: "cliente",
      key: "cliente",
    },
    {
      title: "Vendedor",
      dataIndex: "vendedor",
      key: "vendedor",
    },
    {
      title: "Total Facturas",
      dataIndex: "totalFacturas",
      key: "totalFacturas",
    },
    {
      title: "Consecutivo",
      dataIndex: "consecutivo",
      key: "consecutivo",
    },
    {
      title: "Bodega",
      dataIndex: "bodega",
      key: "bodega",
    },
    {
      title: "Productos Nombre",
      dataIndex: "productosNombre",
      key: "productosNombre",
    },
    {
      title: "Productos Cantidad",
      dataIndex: "productosCantidad",
      key: "productosCantidad",
    },
    {
      title: "Impuesto",
      dataIndex: "impuesto",
      key: "impuesto",
    },
    {
      title: "Total Factura",
      dataIndex: "totalFactura",
      key: "totalFactura",
    },
  ];

  return (
    <Layouts>
      <Space>
        <Button
          onClick={() => {
            let fecha = moment().format("YYYY/MM/DD");
            let fechayhorainicial = moment(fecha + " 12:00:00")
              .utcOffset(-5)
              .format("YYYY-MM-DDTHH:mm:ss-05:00");
            let fechayhorafinal = moment(fecha + " 23:59:00")
              .utcOffset(-5)
              .format("YYYY-MM-DDTHH:mm:ss-05:00");
            setStartDate(fechayhorainicial);
            setEndDate(fechayhorafinal);
            if (userselect) {
              cargarReporte(userselect, fechayhorainicial, fechayhorafinal);
            }
          }}
        >
          Hoy
        </Button>
        <RangePicker
          format={{ format: "YYYY/MM/DD HH:mm:ss", type: "mask" }}
          onChange={onRangeChange}
          placeholder={["Fecha inicial", "Fecha final"]}
        />
      </Space>
      <br />
      <Space>
        <DirectoryTree
          showLine={true}
          onSelect={selectTree}
          treeData={treeData}
        />
      </Space>
      <br />
      <Spin spinning={loanding} delay={500}>
        <Space>
          <h3>
            Mostrando filtro entre fechas {startDate} -- {endDate}
          </h3>
          <h3 style={{ color: "green" }}>Total: {total}</h3>
        </Space>
        
        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <div style={{ flex: 1 }}>
            <Chart
              chartType="PieChart"
              width={"100%"}
              height={"400px"}
              loader={<div>Cargando gráfica</div>}
              data={datareporte}
              options={{
                title: "Reporte de facturas por tipo",
                is3D: true,
                backgroundColor: "transparent",
                chartArea: { width: "100%", height: "80%" },
                legend: { position: "bottom" },
              }}
            />
          </div>
          
          <div style={{ flex: 1, padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
            <h3 style={{ marginBottom: 15, textAlign: 'center' }}>Resumen General</h3>
            {(() => {
              let totalPrecioUnitario = 0;
              let totalGeneral = 0;
              let impuestos = new Set();

              vendedores.forEach(factura => {
                // Sumar totalFactura
                let valor = 0;
                if (factura.totalFactura) {
                  valor = parseFloat(factura.totalFactura.replace(/[$,]/g, ''));
                  if (!isNaN(valor)) {
                    totalGeneral += valor;
                  }
                }
                // Sumar impuestos y calcular subtotal sin impuesto
                let impuestoFactura = 0;
                if (factura.impuesto && factura.impuesto !== "") {
                  // Usar solo el primer impuesto si hay varios
                  const imp = factura.impuesto.split(",")[0].trim();
                  impuestos.add(imp);
                  const impNum = parseFloat(imp);
                  if (!isNaN(impNum) && valor > 0) {
                    // Calcular subtotal sin impuesto
                    totalPrecioUnitario += valor / (1 + (impNum / 100));
                  } else {
                    totalPrecioUnitario += valor; // Si no hay impuesto, sumar el total
                  }
                } else {
                  totalPrecioUnitario += valor; // Si no hay impuesto, sumar el total
                }
              });

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', backgroundColor: 'white', borderRadius: '4px' }}>
                    <span><strong>Precio Unitario Total:</strong></span>
                    <span style={{ color: '#1890ff' }}>${totalPrecioUnitario.toFixed(2)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', backgroundColor: 'white', borderRadius: '4px' }}>
                    <span><strong>Impuesto:</strong></span>
                    <span style={{ color: '#52c41a' }}>{impuestos.size > 0 ? Array.from(impuestos).join(", ") : '-'}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', backgroundColor: '#e6f7ff', borderRadius: 4, border: 2, borderColor: '#1890ff' }}>
                    <span><strong>Total General:</strong></span>
                    <span style={{ color: '#1890ff', fontWeight: 'bold' }}>${totalGeneral.toFixed(2)}</span>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
        <Table
          dataSource={vendedores}
          columns={columns}
          rowKey="key"
          loading={loanding}
          pagination={{ pageSize: 10 }}
        />
      </Spin>
    </Layouts>
  );
}

export default Reportetrops;
